import { ColumnConfig } from '@components/design/migrated/Table';
import React, { useState } from 'react';
import {
  ColumnHeader,
  GroupState,
  ItemFeaturesResp,
  ItemModel,
  LeaderboardKpi,
  ModelGroup,
  SaleType,
} from '@models/Products';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { useProductsModelCompare } from '@components/products-compare-modal/ProductsModelCompareContext';
import { FocusArea } from '@components/products-top-5-table/Types';
import ProductsTableCell from '../products-table-cell/ProductsTableCell';
import { DisplayOptions } from '../products-table-filter/Types';
import { useProductAnalyzerGroupEventState } from '../product-table-grouping/utils/ProductAnalyzerGroupContext';

interface Props {
  selectedDisplayType: DisplayOptions;
  leaderboardKpi: LeaderboardKpi;
  itemFeature: ItemFeaturesResp;
  columns: ColumnConfig[];
  isStickyRow?: boolean;
  sortedColumn?: string;
  className?: string;
  currency: string;
  selectedGrowthType: GrowthTypes;
  selectedSaleType: SaleType;
  selectedFocusArea?: FocusArea;
  rowIndex?: number;
  groupState?: GroupState;
}

export const getKeysByOrder = (columns: ColumnConfig[]): string[] => columns.map(({ headerKey }) => headerKey);

export const isItemModel = (type: string): boolean => type === ItemModel;

export const isModelGroup = (type: string): boolean => type === ModelGroup;

const ProductsTableRow: React.FC<Props> = ({
  selectedDisplayType,
  leaderboardKpi,
  itemFeature,
  columns,
  isStickyRow,
  sortedColumn,
  className,
  currency,
  selectedGrowthType,
  selectedSaleType,
  selectedFocusArea = FocusArea.market,
  rowIndex,
  groupState,
}) => {
  const { selectModel, isModelSelected } = useProductsModelCompare();
  const { selectModelGroup, selectModelsName } = useProductAnalyzerGroupEventState();
  const headerKeys = getKeysByOrder(columns);
  const [isRowHovered, setIsRowHovered] = useState<boolean>(false);

  const selectModelForCompareAndGroup = (itemId: string, itemBrand: string, itemName: string) => {
    //to be change in future, when group can be compared
    if (!groupState) {
      selectModel(itemId);
      selectModelGroup(itemId);
      selectModelsName(`${itemBrand} ${itemName}`);
    }
  };
  const mouseHovered = (isHovered: boolean) => {
    setIsRowHovered(isHovered);
  };

  return (
    <tr
      className={className}
      onClick={(event) => {
        if (leaderboardKpi.item.itemId) {
          event.stopPropagation();
          event.preventDefault();
          selectModelForCompareAndGroup(
            leaderboardKpi.item.itemId,
            leaderboardKpi.item.itemBrand,
            leaderboardKpi.item.itemName,
          );
        }
      }}
      onMouseEnter={() => mouseHovered(true)}
      onMouseLeave={() => mouseHovered(false)}
      style={{ zIndex: groupState?.isGroupingHeader ? groupState.groupSize! - 1 : undefined }}
    >
      {headerKeys.map((headerKey) => {
        return (
          <ProductsTableCell
            selectedDisplayType={selectedDisplayType}
            key={headerKey}
            headerKey={headerKey}
            leaderboardKpi={leaderboardKpi}
            itemFeature={itemFeature}
            isStickyRow={isStickyRow}
            isItemModel={isItemModel(headerKey)}
            sortedColumn={sortedColumn}
            currency={currency}
            selectedGrowthType={selectedGrowthType}
            selectedSaleType={selectedSaleType}
            selectedFocusArea={selectedFocusArea}
            rowIndex={rowIndex}
            {...(headerKey === ColumnHeader.checkbox && {
              isChecked: isModelSelected(leaderboardKpi.item.itemId),
            })}
            groupState={groupState}
            isRowHovered={isRowHovered}
          />
        );
      })}
    </tr>
  );
};

export default ProductsTableRow;
